import React, { useMemo, useContext } from "react";
import { Table } from 'semantic-ui-react'
import { injectIntl } from 'react-intl'
import { PdaContext } from 'context'

const ApplicationsCalendarDayTonnage = ({ intl, completedGrainOperationsData, isPastDate, unloadingSelectedSumm, uploadingSelectedSumm }) => {
    const { unloading, uploading, unloadingApproved, uploadingApproved, unloadingNotApproved, uploadingNotApproved } = completedGrainOperationsData;
    const { isPda } = useContext(PdaContext)

    const translates = useMemo(() => ({
        forUnloading: intl.formatMessage({ id: 'title.forUnloading' }),
        forUploading: intl.formatMessage({ id: 'title.forUploading' }),
        approved: intl.formatMessage({ id: 'title.approved' }),
        notApproved: intl.formatMessage({ id: 'title.notApproved' }),
        chosen: intl.formatMessage({ id: 'title.chosen' }),
        wasUnloaded: intl.formatMessage({ id: 'title.wasUnloaded' }),
        wasUploaded: intl.formatMessage({ id: 'title.wasUploaded' })
    }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {isPda ?
                isPastDate ?
                    <>
                        <Table celled striped unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan='3' textAlign='center'>{translates.wasUnloaded}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell colSpan='3' textAlign='center' >{unloading}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                        <Table celled striped unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan='3' textAlign='center'>{translates.wasUploaded}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell colSpan='3' textAlign='center' >{uploading}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </>
                    :
                    <>
                        <Table celled striped unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan='3' textAlign='center'>{translates.forUnloading}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign='center' >{translates.approved}</Table.Cell>
                                    <Table.Cell textAlign='center' >{translates.notApproved}</Table.Cell>
                                    <Table.Cell textAlign='center' >{translates.chosen}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign='center' >{unloadingApproved}</Table.Cell>
                                    <Table.Cell textAlign='center' >{unloadingNotApproved}</Table.Cell>
                                    <Table.Cell textAlign='center' >{unloadingSelectedSumm}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                        <Table celled striped unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan='3' textAlign='center'>{translates.forUploading}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign='center' >{translates.approved}</Table.Cell>
                                    <Table.Cell textAlign='center' >{translates.notApproved}</Table.Cell>
                                    <Table.Cell textAlign='center' >{translates.chosen}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign='center' >{uploadingApproved}</Table.Cell>
                                    <Table.Cell textAlign='center' >{uploadingNotApproved}</Table.Cell>
                                    <Table.Cell textAlign='center' >{uploadingSelectedSumm}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </>
                :
                isPastDate ?
                    <Table celled striped unstackable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='3' textAlign='center'>{translates.wasUnloaded}</Table.HeaderCell>
                                <Table.HeaderCell colSpan='3' textAlign='center'>{translates.wasUploaded}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell colSpan='3' textAlign='center' >{unloading}</Table.Cell>
                                <Table.Cell colSpan='3' textAlign='center' >{uploading}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                    :
                    <Table celled striped unstackable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='3' textAlign='center'>{translates.forUnloading}</Table.HeaderCell>
                                <Table.HeaderCell colSpan='3' textAlign='center'>{translates.forUploading}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell textAlign='center' >{translates.approved}</Table.Cell>
                                <Table.Cell textAlign='center' >{translates.notApproved}</Table.Cell>
                                <Table.Cell textAlign='center' >{translates.chosen}</Table.Cell>
                                <Table.Cell textAlign='center' >{translates.approved}</Table.Cell>
                                <Table.Cell textAlign='center' >{translates.notApproved}</Table.Cell>
                                <Table.Cell textAlign='center' >{translates.chosen}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell textAlign='center' >{unloadingApproved}</Table.Cell>
                                <Table.Cell textAlign='center' >{unloadingNotApproved}</Table.Cell>
                                <Table.Cell textAlign='center' >{unloadingSelectedSumm}</Table.Cell>
                                <Table.Cell textAlign='center' >{uploadingApproved}</Table.Cell>
                                <Table.Cell textAlign='center' >{uploadingNotApproved}</Table.Cell>
                                <Table.Cell textAlign='center' >{uploadingSelectedSumm}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
            }
        </>
    )
}

export default injectIntl(ApplicationsCalendarDayTonnage);